<template>
    <div class="home-page">
      <div class="header-bgfff">
        <Header></Header>
        <div class="nav">
          <div class="back" @click="back">
            <img width="80" src="../../static/images/back2.png" />
          </div>
        </div>
      </div>
        <div class="nav-list ac">
          <div class="nav-li" v-for="(item,index) in typeList" @click="getToNav(item)" :class="{'active':item.id==type}">
            {{item.title}}
          </div>
        </div>
		<div class="sentences-detail">
      <div class="sentences-content">
        <div class="sentences-type" v-for="(item,index) in themeList" @click="getThemeType(item,index)" :class="{'active':item.id==themeId}" :ref="'themeItem_' + index">
          <img :src="item.image">
          <div class="ac">
            <div class="fw7">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="sentences-detail-ct mt50">
        <div class="scenario-select disflex" @click="getSelectList()" :class="{'active':isSelectShow}">
          <span class="select-span">{{scenarioType}}</span>
          <div class="select-icon"><img width="100" src="../../static/images/Drop-Up.png" /></div>
        </div>
        <div class="select-list" v-if="isSelectShow">
          <div class="select-li" v-for="(item,index) in scenarioList" @click="getScenarioClick(item)" :class="{'active':item.title==scenarioType}"> {{item.title}} </div>
        </div>
        <div class="hanzi-content mt30">
          <div class="hanzi-list">
            <div class="hanzi-bottom">
              <div class="hanzi-c" v-for="(item,index) in currentScenarioDetail.chText">
                <span class="pinyin">{{currentScenarioDetail.spell[index]}}</span>
                <div class="hanzi-t" :class="{'noMargin':isHtmlTag(item)}">
                  <div class="wenz" v-for="(item1,index) in item" v-if="!isHtmlTag(item)">
                    <span>{{item1}}</span>
                    <img src="../../static/images/pinyin.png" />
                  </div>
                  <div class="wenz" v-if="isHtmlTag(item)">
                    <div v-html="item"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="eng-tips">
              <strong>{{$t('English_tip')}}:</strong>
              <span>{{currentScenarioDetail.enText}}</span>
            </div>
            <audio
              ref="audioSentence"
              :src="currentScenarioDetail.sound_path"
              playsinline
              webkit-playsinline
              style="display: none;"
            ></audio>
          </div>
        </div>

        <div class="divider ac mt50">
          <img @click="initAudioPlayback" src="../../static/images/repeat.png">
          <div class="crff6600">{{$t('Replay')}}</div>
        </div>
        <footer class="navigation disflex mt50">
          <button
            class="button pre-button font-family"
            @click="Previous"
            :disabled="scenario_num === 0"
          >{{$t('Previous')}}</button>
          <button
            class="button next-button font-family"
            @click="Next"
            :disabled="scenario_num === scenario_num_all - 1"
          >{{$t('Next')}}</button>
        </footer>
        <div class="progress fw7 fs27 mt50 ac">{{ scenario_num + 1 }} of {{ scenario_num_all }}</div>
      </div>

		</div>
    <div class="ac mt50">
      <button style="padding: 20px 40px;width: 320px;"
        class="button pre-button font-family"
        @click="back"
      >{{$t('back')}}</button>
      <button
    </div>
      <!-- <div class="footer mt50">
        <div class="home-bottom ac mt50">
          <div class="footer-content ac">
            <a class="crfff" href="#/faq">{{$t('FAQ')}}</a>
            <a class="crfff" href="#/termsAndCondition">{{$t('TC')}}</a>
          </div>
        </div>
        <div class="copyright">{{$t('Copyright')}}</div>
      </div> -->
	</div>
</template>
<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        themeList:[],
        typeList:[],
        type:'',
        themeId:'',
        scenarioType:'',
        scenarioList:[],
        scenarioInfo:{
          detail:[{chText:[],'spell':[]}]
        },
        isSelectShow:false,
        scenario_num:0,
        scenario_num_all:0,
        isFirst:true,
      }
    },
    computed: {
      // 添加计算属性来安全访问当前详情
      currentScenarioDetail() {
        if (this.scenarioInfo.detail && this.scenarioInfo.detail.length > 0) {
          return this.scenarioInfo.detail[this.scenario_num] || {};
        }
        return null;
      }
    },
  beforeRouteLeave(to, from, next) {
    if (this.$parent) {
      this.$parent.bgmEnabled = true;        // 允许播放
    }
    next();  // 继续导航
  },
	created(){
    // 暂停背景音乐
    if (this.$parent && this.$parent.stopBackgroundMusic) {
      this.$parent.stopBackgroundMusic(true);
      this.$parent.bgmEnabled = false;
    }
    this.type = this.$route.query.type_id
    this.themeId = this.$route.query.theme_id
    this.getType();
	},
    methods: {
       // 判断是否是HTML标签
      isHtmlTag(str) {
        return /<[a-z][\s\S]*>/i.test(str);
      },
      initAudioPlayback() {
        this.pauseAllAudios();
        this.$nextTick(() => {
          if (this.$refs.audioSentence) {
            this.$refs.audioSentence.play().catch(e => console.log("自动播放被阻止"));
          }
        });
      },
      pauseAllAudios() {
        if (this.$refs.audioSentence) {
          this.$refs.audioSentence.pause();
          this.$refs.audioSentence.currentTime = 0;
        }
      },
      Next() {
        let that = this;
        if (this.scenario_num < this.scenario_num_all - 1) {
          this.scenario_num++;
          this.$nextTick(() => {
            this.initAudioPlayback()
          });
        }
      },
      Previous() {
        if (this.scenario_num > 0) {
          this.scenario_num--;
          this.$nextTick(() => {
            this.initAudioPlayback()
          });
        }
      },
      getSelectList(){
        this.isSelectShow = !this.isSelectShow
      },
      back(){
      	this.$router.push({path:'/'});
      },
      getToNav(item){
        this.type = item.id
        this.isFirst = false
        this.getTheme();
      },
      getType(){
        let that = this
        that.$parent.loadModal(true);
        that.$api.post('/api/study1000/get_module',null,r =>{
          that.$parent.returnCode(r,function(){
            that.typeList = r.data
            that.getTheme()
            that.$parent.loadModal(false);
          })
        })
      },
      getTheme(){
        let that = this
        let data = {
          "module_id":this.type
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/study1000/get_theme',data,r =>{
          that.$parent.returnCode(r,function(){
            that.themeList = r.data
            if(!that.isFirst){
              that.$router.push({path:'/Sentences300Detail',query: {theme_id:r.data[0].id,type_id:that.type}});
            }else{
              that.$nextTick(() => {
                let index = that.themeList.findIndex(item => item.id == that.$route.query.theme_id);
                if (index !== -1 && that.$refs[`themeItem_${index}`] && that.$refs[`themeItem_${index}`][0]) {
                  const activeElement = that.$refs[`themeItem_${index}`][0];
                  setTimeout(() => {
                    activeElement.scrollIntoView({
                      behavior: 'smooth',
                      block: 'nearest',
                      inline: 'center'
                    });
                  }, 100);
                }
              });
            }
            that.themeId = that.$route.query.theme_id
            that.getScenario()
            that.$parent.loadModal(false);
          })
        })
      },
      getThemeType(item,index){
        this.themeId = item.id
        this.$router.push({path:'/Sentences300Detail',query: {theme_id:item.id,type_id:this.type}});
        this.getScenario()
        this.$nextTick(() => {
          const activeElement = this.$refs[`themeItem_${index}`][0];
          if (activeElement) {
            activeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center'
            });
          }
        });
      },
      getScenario(){
        let that = this
        let data = {
          "theme_id":this.themeId
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/study1000/get_scenario',data,r =>{
          that.$parent.returnCode(r,function(){
            that.scenarioList = r.data
            that.scenarioType = r.data[0].title
            that.getScenarioClick(r.data[0])
            that.$parent.loadModal(false);
          })
        })
      },
      getScenarioClick(item){
        let that = this
        that.scenarioType = item.title
        that.isSelectShow = false
        let data = {
            "scenario_id":item.id
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/study1000/get_scenario_detail',data,r =>{
          that.$parent.returnCode(r,function(){
            that.scenarioInfo = r.data
            that.scenario_num = 0
            that.scenario_num_all = that.scenarioInfo.detail.length
            that.initAudioPlayback();
            that.$parent.loadModal(false);
          })
        })
      },
	}
}
</script>
<style scoped>
.sentences-content {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  scroll-behavior: smooth; /* 平滑滚动 */
  padding: 10px 0;
}

.sentences-type {
}
</style>



// WEBPACK FOOTER //
// src/page/Sentences300Detail.vue